import React, { forwardRef, useEffect, useImperativeHandle } from 'react';
import FileList from '../FileList';
import * as Utils from 'utils';

export const apiKey = process.env.REACT_APP_ENV === 'local' ? '36io4c9jam4a283' : window.serviceList.dropbox.appKey;

const Dropbox = forwardRef(({
  files,
  onCreateFiles,
  onDeleteFileByHash
}, ref) => {
  const choose = (event) => {
    window.Dropbox.choose({
      iframe: false,
      linkType: "direct",
      multiselect: true,
      extensions: "",
      success: (files) => {
        onCreateFiles(files.map(file => ({
          hash: Utils.randomHash(),
          name: file.name,
          type: file.linkType,
          size: file.bytes,
          destination: file.link
        })));
      },
    });

    event.preventDefault();
    event.stopPropagation();
  };

  useEffect(() => {
    const dropbox = document.getElementById('dropboxjs');

    if (!dropbox) {
      const domElementHead = document.getElementsByTagName('head')[0];
      const domElementScript = document.createElement("script");

      domElementScript.setAttribute('type', 'text/javascript');
      domElementScript.setAttribute('src', 'https://www.dropbox.com/static/api/1/dropbox.js');
      domElementScript.setAttribute('id', 'dropboxjs');
      domElementScript.setAttribute('data-app-key', apiKey);
      domElementHead.append(domElementScript);
    }
  }, []);

  useImperativeHandle(ref, () => ({
    choose(event) { choose(event); }
  }))

  return (<FileList files={files} onDeleteByHash={onDeleteFileByHash}/>);
});

export default Dropbox;
